
	import { Observer } from 'mobx-vue';
	import { Component, InjectReactive } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import NewHelpModal from '@/components/new-prescription/help-modal/NewHelpModal.vue';

	@Observer
	@Component({
		components: { NewHelpModal }
	})
	export default class PrescriptionItemWrapper extends PrescriptionItem {
		@InjectReactive() hamburgerView!: boolean;
		private showHelpModal: boolean = false;
	}
